import SessionStorage from "@casino/client/utils/storage/SessionStorage";
import { usePathname } from "next/navigation";

const usePathHistory = () => {
  const asPath = usePathname();
  const savePreviousPath = () => {
    SessionStorage.setItem("previousPath", asPath ?? "/");
  };

  const getPreviousPath = (): string | null =>
    SessionStorage.getItem("previousPath");

  return {
    savePreviousPath,
    getPreviousPath,
  };
};

export default usePathHistory;
